
import { SMTasks } from "@/store";
import { defineComponent, ref, computed, watch } from "vue-demi";

export default defineComponent({
  name: "TaskRTWCTemplate",
  components: {
    RTWCStep1: () => import("./RTWCStep1.vue"),
    RTWCStep2: () => import("./RTWCStep2.vue"),
  },
  setup() {
    const step = ref(1);

    const response = ref({
      days_left: 0,
      file_id: 0,
    });

    const fileId = computed<number>(() => SMTasks.taskTemplate?.file_id ?? 0);

    const isTaskArchived = computed<boolean>(() => SMTasks.taskTemplate?.status === "archived");

    const isRTWCCompleted = ref(false);
    const isRTWCStarted = ref(false);

    watch(
      () => [fileId.value, isTaskArchived.value],
      ([id, isArchived]) => {
        if (id && isArchived) {
          response.value.file_id = id as number;
          step.value = 2;
          isRTWCStarted.value = false;
          isRTWCCompleted.value = true;
        } else if (id) {
          response.value.file_id = id as number;
          step.value = 2;
          isRTWCStarted.value = true;
        }
      },
      { immediate: true }
    );

    function proceed(payload) {
      Object.assign(response.value, payload);

      step.value = 2;
    }

    const step2Key = ref(0);

    function restart() {
      isRTWCStarted.value = false;
      isRTWCCompleted.value = false;

      Object.assign(response.value, {
        days_left: 0,
        file_id: 0,
      });

      step2Key.value += 1;

      step.value = 1;
    }

    return {
      step,
      fileId,
      response,
      step2Key,
      proceed,
      restart,
      isRTWCStarted,
      isRTWCCompleted,
    };
  },
});
